export default __webpack_public_path__ + "static/media/ic-students.23ac3896.svg";